import { memo } from 'react';

import useLocale from '../../../hooks/useLocale';
import { RewardOffer } from '../../../models/RewardStore';
import { JoyajoyImage } from '../JoyajoyImage';

import styles from './WebStoreProductNode.module.css';

export type WebStoreProductNodeProps = {
  rewardOffer: RewardOffer;
  onClickProduct: () => void;
};

export const WebStoreProductNode = memo((props: WebStoreProductNodeProps) => {
  const { rewardOffer, onClickProduct } = props;

  const l = useLocale();

  const rewardOfferinfo = l(rewardOffer.i18nRewardOfferInfo);

  const rewardOfferImage =
    rewardOfferinfo.carousel[0]?.image?.publicUrls?.medium ?? '';

  return (
    <div className={styles.productNode}>
      <div className={styles.centeredContainer} onClick={onClickProduct}>
        <div className={styles.iconContainer}>
          <JoyajoyImage
            className={styles.productImage}
            resource={{ uri: rewardOfferImage }}
          />
        </div>
        <div className={styles.textComponent}>
          <p className={styles.name}>{rewardOfferinfo.name}</p>
        </div>
      </div>
    </div>
  );
});
